module.exports = __webpack_public_path__ + "static/media/Paramount_Pics_logo.5d4235a7.png";